import React from 'react';
import './Home.css'; // Make sure this file includes the updated styles below
import Image1 from './../Assets/dr.jpg'
import Image2 from './../Assets/ourWorks2.jpg'
import Image3 from './../Assets/ourWorks3.jpg'
import Image4 from './../Assets/ourWorks4.jpg'


const worksData = [
  {
    title: 'Strategic Visual Branding',
    description: 'Crafted a unique and consistent brand identity.',
    image: Image1,
  },
  {
    title: 'Smart E Commerce Solutions',
    description: 'Built a scalable, secure online store with smooth user experience',
    image: Image2,
  },
  {
    title: 'Crafting Brand Stories',
    description: 'Discover the visual and strategic work behind our client brands.',
    image: Image3,
  },
  {
    title: 'The Art of Branding',
    description: 'Highlighting how we shape and define brand identities across industries.',
    image: Image4,
  },
];

function Ourworks() {
  return (
    <div className="our-works-section">
      <div className="our-works-text">
        <h3 className="poppinsx">Our Works</h3>
        <p className="poppin">
          Personal branding is the process of establishing 
          and promoting a unique identity and image for
          oneself, typically in a professional context.
        </p>
      </div>

      <div className="our-works-grid">  
  {worksData.map((work, index) => (
    <div style={{ height: 'auto' }} className="work-card" key={index}>
      <div className="image-wrapper">
        <img src={work.image} alt={work.title} />
        <div className="overlay"></div> {/* Black overlay */}
      </div>
      <div className="card-content">
        <h4 className="work-title poppinsx">{work.title}</h4>
        <p className="work-description poppins">{work.description}</p>
      </div>
    </div>
  ))}
</div>

    </div>
  );
}

export default Ourworks;